import PropTypes from "prop-types";

import GLERow from "./GleRow";

const StandardCard = ({ dataType, includedKeys, node, isOpen, onToggle, selectedKeys, onToggleItem }) => {
    return (
        <div className="diff-standard-card mb-3">
            <button
                type="button"
                className="diff-standard-card__header d-flex justify-content-between align-items-center w-100 text-start"
                onClick={onToggle}
                aria-expanded={isOpen ? "true" : "false"}
                aria-controls={`std-body-${node.id ?? node.key}`}
            >
                <div className="fw-semibold fs-6">
                    <span className="me-1">Standard:</span>
                    <span>{node.label}</span>
                </div>
                <span aria-hidden="true" className="diff-standard-card__chevron ms-2">
                    {isOpen ? "▾" : "▸"}
                </span>
            </button>

            {isOpen && (
                <div id={`std-body-${node.id ?? node.key}`} className="diff-standard-card__body">
                    {node.children?.map((gle) => (
                        <GLERow
                            key={gle.id ?? gle.key}
                            dataType={dataType}
                            includedKeys={includedKeys}
                            node={gle}
                            onToggleItem={onToggleItem}
                            selectedKeys={selectedKeys}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

StandardCard.propTypes = {
    dataType: PropTypes.string,
    includedKeys: PropTypes.object,
    node: PropTypes.object.isRequired,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
    selectedKeys: PropTypes.instanceOf(Set),
    onToggleItem: PropTypes.func
};

StandardCard.defaultProps = {
    dataType: "",
    includedKeys: {},
    isOpen: false,
    onToggle: () => {},
    selectedKeys: new Set(),
    onToggleItem: () => {}
};

export default StandardCard;
